<template>
  <div class="page">
    <div class="page_contents">
      <div class="page_header">회원가입</div>
      <div class="page_header_line"></div>

      <div class="join_div">
        <div class="join_desc">
          <div>고객님께서 해당하는 회원의 종류를 선택해주세요</div>
          <div>회원가입 후 최종 승인이 완료되면 정상적인 서비스 이용이 가능합니다.</div>
          <div>통합회원과 일반회원을 반드시 구분하여 가입 하시기 바라며, 로그인 시 자동으로 권한에 따라 컨텐츠가 구분됩니다.</div>
        </div>
        <div class="join_type_div">
          <div class="join_type_sub_div">
            <div class="join_label">통합회원</div>
            <div class="join_sub_label">(수주+수행)</div>
            <img class="join_type_img" src="@/assets/images/join_total_img.png" alt="" />
            <div class="join_btn" @click="emit('setType','통합')">회원가입</div>
          </div>
          <div class="join_type_sub_line"></div>
          <div class="join_type_sub_div">
            <div class="join_label">일반회원</div>
            <div class="join_sub_label">(수주)</div>
            <img class="join_type_img" src="@/assets/images/join_normal_img.png" alt="" />
            <div class="join_btn" @click="emit('setType','수주')">회원가입</div>
          </div>
        </div>
      </div>
    </div>    
  </div>
</template>
<script setup lang="ts">
import {defineEmits} from "vue";

const emit = defineEmits(["setType"]);
</script>

<style scoped>
.page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;
}

.page_header {
  padding-top: 60px;
  padding-bottom: 16px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 24px;
  left: 33px;
  /* text-align: center; */
}

/* .page_header {
  width: 100%;
} */

.page_contents {
  display: flex;
  width: 100%;
  flex-direction: column;
  /* gap: 30px; */
  align-items: center;
}

.join_type_div {
  width: 754px;
  height: 395px;
  display: flex;
  border: 1px solid #d0d0d0;
  box-shadow: 4px 4px 8px 0px #0000000d;
  align-items: center;
  border-radius: 15px;
}

.join_type_sub_div {
  width: 50%;
  display: flex;
  align-items: center;
  font-size: 20px;
  font-family: "Noto Sans CJK KR-Bold";
  /* border: 1px solid #ccc; */
  flex-direction: column;
  padding: 58px 0px;
}
.join_type_sub_line {
  border-right: 1px solid #aaaaaa;
  height: 246px;
}
.join_label {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 20px;
  height: 27px;
  color: black;
  margin-bottom: 5px;
}
.join_sub_label {
  font-family: "Noto Sans CJK KR-Light";
  font-size: 16px;
  height: 22px;
  color: #535353;
  margin-bottom: 25px;
}
.join_type_img {
  margin-bottom: 40px;
}
.join_btn {
  background: #3382e9;
  padding: 10px 20px;
  font-size: 16px;
  font-family: "Noto Sans CJK KR-Bold";
  width: 101px;
  height: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
  border-radius: 7px;
}

.join_desc {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 21px;
  color: #6d6d6d;
  text-align: center;
  margin-bottom: 50px;
}

.join_div {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page_contents {
  width: 800px;
}

.steps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 696px;
}

.step {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.step_circle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  width: 12px;
  height: 12px;
  background: #d8d8d8;
  position: relative;
}

.step.active .step_circle {
  border: 3px solid #337ab7;
  width: 18px;
  height: 18px;
  background: white;
}

.step.active .step_circle div {
  color: #337ab7;
}

.step_line {
  height: 2px;
  background: #d8d8d8;
  width: 214px;
}
.active .step_line {
  width: 208px;
}
.step_labels {
  display: flex;
  flex-direction: row;
  /* width: 765px; */
}

.step_label {
  position: absolute;
  width: 150px;
  text-align: center;
  bottom: -31px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Regular";
  line-height: 19px;
}
.page_header_line {
  width: 36px;
  border-bottom: 2px solid #000000;
  margin-bottom: 20px;
}
</style>
